<template>
  <div class="yxtj-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="收款日期">
              <el-date-picker v-model="searchForm.time" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="daterange"
                :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="组织">
              <el-select v-model="searchForm.groupid" style="width: 120px" @keyup.enter.native="Search" filterable>
                <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name"
                  :value="item.groupid" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
            </el-form-item>
          </el-form>

          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="24" v-loading="loading">
                <div class="chart-column">
                  <GraphicsChart id="column" :option="columnOption" />
                </div>
              </el-col>
              <!-- <el-col :span="10" v-loading="loading">
                <GraphicsChart id="circle" :option="circleOption"></GraphicsChart>
              </el-col> -->
              <el-col :span="24" v-loading="tbLoading">
                <div style="padding-top: 20px; margin-top: 20px; border-top: 1px solid #ebeef5;">
                  <div class="card-title" style="float: left;">
                    {{ typeName }}统计数据明细表
                  </div>
                  <el-button v-show="typeName" icon="el-icon-printer" style="float: right; margin-bottom: 10px;"
                    size="small" :loading="excelLoading" @click="exportExcel">导出Excel</el-button>
                  <el-button v-show="typeName" icon="el-icon-refresh"
                    style="float: right; margin: 0 12px; margin-bottom: 10px;" size="small"
                    @click="reloadTable">刷新</el-button>
                </div>
                <div v-if="!typeName" style="height: 100px; line-height: 100px; text-align: center;">请先点击柱形图选择统计类型</div>
                <el-table v-show="typeName" :data="tableData" stripe style="width: 100%" show-overflow-tooltip>
                  <el-table-column v-for="(item, index) in tableColumns" :key="index" :prop="item.prop"
                    :label="item.label" :width="item.minWidth ? '' : item.width || 100" :min-width="item.minWidth"
                    :align="item.align || 'center'" :fixed="item.fixed || false">
                    <template slot-scope="scope">
                      <span :style="item.color ? `color: ${item.color};` : ''">
                        {{ item.type == 'option' ? item.optionObj[`${scope.row[item.prop]}`] || '' : scope.row[item.prop] }}
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination v-show="typeName && page.total > 0" style="margin-top:10px;" background
                  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.currentPage"
                  :page-sizes="[10, 20, 50]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="page.total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>

          <div class="card-content custom-table"
            style="margin-top: 40px; padding-top: 20px; border-top: 1px solid #ebeef5;">
            <el-form style="margin-bottom: 10px;" :inline="true" size="small" :model="allSearchForm"
              @submit.native.prevent>
              <el-form-item label="统计日期">
                <el-date-picker v-model="allSearchForm.time" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="date"
                  :clearable="false" placeholder="统计日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="组织">
                <el-select v-model="allSearchForm.groupid" style="width: 120px" @keyup.enter.native="AllSearch"
                  filterable>
                  <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name"
                    :value="item.groupid" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="getAllData">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <div style="margin: 0 10px; color: red;">统计金额单位：<span style="font-weight: bold;">{{ unit }}</span></div>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-refresh"
                  @click="unit = unit == '万元' ? '元' : '万元'">切换为：{{ unit == '万元' ? '元' : '万元' }}</el-button>
              </el-form-item>
            </el-form>

            <div class="card-title" style="float: left;">收款统计</div>
            <el-row :gutter="12" v-loading="kfLoading || allLoading">
              <el-col :span="24">
                <el-button style="margin: 10px 0; float: right;" icon="el-icon-printer" size="small"
                  :loading="excelLoading" @click="exportKfExcel(0)">导出Excel1</el-button>
                <el-table :data="kfList" border :header-cell-style="{fontWeight: '600'}" max-height="600px"
                  :row-class-name="rowClassName" style="width: 100%">
                  <el-table-column label="" align="center">
                    <template #header>
                      <div style="font-size: 17px; font-weight: bold;">
                        {{ allSearchForm.time_str }} {{ allSearchForm.brand }}品牌 全国<span
                          style="color: red;">销售客服收款</span>总金额 ({{ unit }})
                      </div>
                    </template>
                    <el-table-column prop="name" label="销售客服" align="center" min-width="65"></el-table-column>
                    <el-table-column prop="dayMoneyStr" label="当日金额" align="center" min-width="80">
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.dayMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="allSearchForm.month_str + '累计至当日'" align="center">
                      <el-table-column prop="monthMoneyStr" label="金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastYearMonthMoneyStr" label="同期金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastYearMonthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthRate" label="同比" align="center" min-width="80"></el-table-column>
                    </el-table-column>
                    <el-table-column label="全年累计至当日" align="center">
                      <el-table-column prop="yearMoneyStr" label="金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.yearMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastYearMoneyStr" label="同期金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastYearMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="yearRate" label="同比" align="center" min-width="80"></el-table-column>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>

              <el-col :span="24">
                <el-button style="margin: 10px 0; float: right;" icon="el-icon-printer" size="small"
                  :loading="excelLoading" @click="exportKfExcel(1)">导出Excel2</el-button>
                <el-table :data="kfList1" border :header-cell-style="{fontWeight: '600'}" max-height="600px"
                  :row-class-name="rowClassName" style="width: 100%">
                  <el-table-column label="" align="center">
                    <template #header>
                      <div style="font-size: 17px; font-weight: bold;">
                        {{ allSearchForm.time_str }} {{ allSearchForm.brand }}品牌 全国<span
                          style="color: red;">区域经理收款</span>总金额 ({{ unit }})
                      </div>
                    </template>
                    <el-table-column prop="name" label="区域经理" align="center" min-width="65"></el-table-column>
                    <el-table-column prop="dayMoneyStr" label="当日金额" align="center" min-width="80">
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.dayMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="allSearchForm.month_str + '累计至当日'" align="center">
                      <el-table-column prop="monthMoneyStr" label="金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastYearMonthMoneyStr" label="同期金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastYearMonthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthRate" label="同比" align="center" min-width="80"></el-table-column>
                    </el-table-column>
                    <el-table-column label="全年累计至当日" align="center">
                      <el-table-column prop="yearMoneyStr" label="金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.yearMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastYearMoneyStr" label="同期金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastYearMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="yearRate" label="同比" align="center" min-width="80"></el-table-column>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

          <div class="card-content custom-table"
            style="margin-top: 40px; padding-top: 20px; border-top: 1px solid #ebeef5;">
            <div class="card-title" style="float: left;">区域负责人统计</div>
            <el-row :gutter="12" v-loading="qyLoading || allLoading">
              <el-col :span="24">
                <el-button style="margin: 10px 0; float: right;" icon="el-icon-printer" size="small"
                  :loading="excelLoading" @click="exportQyExcel(1)">导出Excel3</el-button>
                <el-table :data="qyList2" border :header-cell-style="{fontWeight: '600'}" max-height="600px"
                  :row-class-name="rowClassName" style="width: 100%">
                  <el-table-column label="" align="center">
                    <template #header>
                      <div style="font-size: 17px; font-weight: bold;">
                        {{ allSearchForm.time_str }} {{ allSearchForm.brand }}品牌 全国<span
                          style="color: red;">下单</span>总金额 ({{ unit }})<span style="font-size: 12px;">（含冲业绩）</span>
                      </div>
                    </template>
                    <el-table-column prop="name" label="区域负责人" align="center" min-width="65"></el-table-column>
                    <el-table-column prop="dayMoneyStr" label="当日金额" align="center" min-width="80">
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.dayMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="allSearchForm.month_str + '累计至当日'" align="center">
                      <el-table-column prop="monthMoneyStr" label="金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastYearMonthMoneyStr" label="同期金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastYearMonthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthRate" label="同比" align="center" min-width="80"></el-table-column>
                    </el-table-column>
                    <el-table-column label="全年累计至当日" align="center">
                      <el-table-column prop="yearMoneyStr" label="金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.yearMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastYearMoneyStr" label="同期金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastYearMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="yearRate" label="同比" align="center" min-width="80"></el-table-column>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>

              <el-col :span="24">
                <el-button style="margin: 10px 0; float: right;" icon="el-icon-printer" size="small"
                  :loading="excelLoading" @click="exportQyExcel(2)">导出Excel4</el-button>
                <el-table :data="qyList3" border :header-cell-style="{fontWeight: '600'}" max-height="600px"
                  :row-class-name="rowClassName" style="width: 100%">
                  <el-table-column label="" align="center">
                    <template #header>
                      <div style="font-size: 17px; font-weight: bold;">
                        {{ allSearchForm.time_str }} {{ allSearchForm.brand }}品牌 全国<span
                          style="color: red;">下单</span>总业绩详情 ({{ unit }})
                      </div>
                    </template>
                    <el-table-column prop="name" label="区域负责人" align="center" min-width="65"></el-table-column>
                    <el-table-column :label="allSearchForm.month_str + '累计至当日'" align="center">
                      <el-table-column prop="monthMoneyStr" label="下单金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthCyjMoneyStr" label="冲业绩金额x2" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthCyjMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastMonthCyjMoneyStr" label="上月冲业绩金额x2" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastMonthCyjMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthCyjXdMoneyStr" label="本月冲业绩下单" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthCyjXdMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthYjMoneyStr" label="冲业绩差额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthYjMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthTotalMoneyStr" label="总业绩(下单金额+冲业绩金额x2+冲业绩差额)" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthTotalMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

          <div class="card-content custom-table"
            style="margin-top: 40px; padding-top: 20px; border-top: 1px solid #ebeef5;">
            <div class="card-title" style="float: left;">经销商统计</div>
            <el-row :gutter="12" v-loading="jxsLoading || allLoading">
              <el-col :span="24">
                <div style="float: left; display: flex; align-items: center; margin: 10px 0;">
                  <span style="margin-right: 8px;">月金额：</span>
                  <div style="width: 20px; height: 12px; background-color: #f8e3c5; margin-right: 4px;"></div>
                  <span style="margin-right: 20px;">10~12万</span>
                  <div style="width: 20px; height: 12px; background-color: #d1edc4; margin-right: 4px;"></div>
                  <span style="margin-right: 20px;">12~18万</span>
                  <div style="width: 20px; height: 12px; background-color: #eebe77; margin-right: 4px;"></div>
                  <span style="margin-right: 20px;">18~20万</span>
                  <div style="width: 20px; height: 12px; background-color: #95d475; margin-right: 4px;"></div>
                  <span style="margin-right: 20px;">20万以上</span>
                </div>
                <el-button style="margin-bottom: 10px; float: right;" icon="el-icon-printer" size="small"
                  :loading="excelLoading" @click="exportJxsExcel(0)">导出Excel5</el-button>
                <el-table :data="jxsList2" border :header-cell-style="{fontWeight: '600'}" max-height="600px"
                  :row-class-name="rowClassName" :cell-style="cellStyleJxsTable" style="width: 100%">
                  <el-table-column label="" align="center">
                    <template #header>
                      <div style="font-size: 17px; font-weight: bold;">
                        {{ allSearchForm.time_str }} {{ allSearchForm.brand }}品牌 全国<span
                          style="color: red;">经销商下单</span>总金额 ({{ unit }})
                      </div>
                    </template>
                    <el-table-column prop="name" label="经销商" align="center" min-width="80"></el-table-column>
                    <el-table-column prop="areaName" label="区域经理" align="center" width="100"></el-table-column>
                    <el-table-column prop="dayMoneyStr" label="当日金额" align="center" min-width="80">
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.dayMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="allSearchForm.month_str + '累计至当日'" align="center">
                      <el-table-column prop="monthMoneyStr" label="金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastYearMonthMoneyStr" label="同期金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastYearMonthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthRate" label="同比" align="center" min-width="80"></el-table-column>
                    </el-table-column>
                    <el-table-column label="全年累计至当日" align="center">
                      <el-table-column prop="yearMoneyStr" label="金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.yearMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="lastYearMoney" label="同期金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.lastYearMoney) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="yearRate" label="同比" align="center" min-width="80"></el-table-column>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="24">
                <el-button style="margin: 10px 0; float: right;" icon="el-icon-printer" size="small"
                  :loading="excelLoading" @click="exportJxsExcel(1)">导出Excel6</el-button>
                <el-table :data="jxsList3" border :header-cell-style="{fontWeight: '600'}" max-height="600px"
                  :row-class-name="rowClassName" style="width: 100%">
                  <el-table-column label="" align="center">
                    <template #header>
                      <div style="font-size: 17px; font-weight: bold;">
                        {{ allSearchForm.time_str }} {{ allSearchForm.brand }}品牌 全国<span
                          style="color: red;">经销商下单</span>业绩 ({{ unit }})
                      </div>
                    </template>
                    <el-table-column prop="name" label="经销商" align="center" min-width="80"></el-table-column>
                    <el-table-column prop="areaName" label="区域经理" align="center" width="100"></el-table-column>
                    <el-table-column :label="allSearchForm.month_str + '累计至当日'" align="center">
                      <el-table-column prop="monthMoneyStr" label="上月下单金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthCyjXdMoneyStr" label="本月冲业绩金额" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthCyjXdMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="monthYjMoneyStr" label="总业绩金额 (上月下单金额+本月冲业绩金额)" align="center">
                        <template slot-scope="scope">
                          <span>{{ parseNumUnit(scope.row.monthYjMoneyStr) }}</span>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    getGroupReport
  } from '@/api/pub'

  import {
    getCollectionStatistics,
    getCollectionDetail,
    excelCollectionDetail,
    getYxtj,
    getServeStatistics,
    getAreaStatistics,
    getDealerOrderStatistics,
  } from '@/api/erp'

  import axios from 'axios'

  import GraphicsChart from '@/components/Charts/GraphicsChart'

  export default {
    name: 'yxtjfx',
    components: {
      GraphicsChart
    },
    computed: {
      user: getUser
    },
    data() {
      return {
        searchForm: {
          time: [],
          months: [],
          groupid: ''
        },
        groupList: [],

        tableData: [],
        totalPrice: 0,
        chartsOption: {
          title: false,
          credits: {
            enabled: false
          }
        },

        loading: false,
        typeName: '',
        statData: [],
        excelLoading: false,

        allSearchForm: {
          time_str: '',
          month_str: '',
          time: '',
          groupid: ''
        },
        allLoading: false,
        unit: '元',

        kfSearchForm: {
          time_str: '',
          month_str: '',
          time: '',
          groupid: ''
        },
        kfLoading: false,
        kfList: [],
        kfList1: [],

        qySearchForm: {
          time_str: '',
          month_str: '',
          time: '',
          groupid: ''
        },
        qyLoading: false,
        qyList1: [],
        qyList2: [],
        qyList3: [],
        qyList4: [],

        jxsSearchForm: {
          time_str: '',
          month_str: '',
          time: '',
          groupid: ''
        },
        jxsLoading: false,
        jxsList1: [],
        jxsList2: [],
        jxsList3: [],

        tbLoading: false,
        tableColumns: [],
        tableData: [],
        dataType: '0',
        page: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },

        columnOption: {
          title: false,
          exporting: {
            enabled: true
          },
          credits: {
            enabled: false
          }
        },
        circleOption: {
          title: false,
          exporting: {
            enabled: true
          },
          credits: {
            enabled: false
          }
        },
      }
    },
    created() {
      const myDate = new Date()
      const year = myDate.getFullYear()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      month = month > 9 ? month + '' : '0' + month
      day = day > 9 ? day + '' : '0' + day
      this.searchForm.time = [year + '-' + month + '-01', year + '-' + month + '-' + day]

      this.allSearchForm.time = year + '-' + month + '-' + day
      this.allSearchForm.time_str = year + '年' + month + '月' + day + '日'
      this.allSearchForm.month_str = month + '月'

      this.searchForm.groupid = this.user.dGroupid

      this.allSearchForm.groupid = this.user.dGroupid
      this.allSearchForm.brand = this.allSearchForm.groupid == 1 ? '首造' : '乔金斯'

      this.getGroupList()

      this.getData();
      this.getAllData();
    },
    methods: {
      parseNumUnit(num = 0) {
        // 万元向下取整
        return this.unit == '万元' ? Math.floor(num / 100) / 100 : num;
      },

      getData() {
        // console.log(this.searchForm)
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          starttime: startTime,
          endtime: endTime,
          groupid: this.searchForm.groupid
        }
        this.loading = true
        getCollectionStatistics(data).then(response => {
          // console.log(response)
          let res_data = response.data || {}
          this.statData = res_data.bars || []
          // 初始图表数据
          this.initChatrsData()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })

        // 初始统计明细数据
        this.getTableData(this.dataType)
      },

      getAllData() {
        this.allLoading = true
        const data = {
          time: this.allSearchForm.time,
          groupid: this.allSearchForm.groupid
        }
        getYxtj(data).then(response => {
          // console.log(response)
          let res_data = response.data || {}
          this.kfList = res_data.sk || []
          this.kfList1 = res_data.sk1 || []

          this.qyList2 = res_data.xd || []
          this.qyList3 = res_data.xd1 || []

          this.jxsList2 = res_data.xd2 || []
          this.jxsList3 = res_data.xd3 || []

          this.allLoading = false

          const myDate = new Date(this.allSearchForm.time)
          const year = myDate.getFullYear()
          let month = myDate.getMonth() + 1
          let day = myDate.getDate()
          month = month > 9 ? month + '' : '0' + month
          day = day > 9 ? day + '' : '0' + day
          this.allSearchForm.time_str = year + '年' + month + '月' + day + '日'
          this.allSearchForm.month_str = month + '月'
          this.allSearchForm.brand = this.allSearchForm.groupid == 1 ? '首造' : '乔金斯'
        }).catch(() => {
          this.allLoading = false
        })
      },

      getKfData() {
        this.kfLoading = true
        const data = {
          time: this.allSearchForm.time,
          groupid: this.allSearchForm.groupid
        }
        getServeStatistics(data).then(response => {
          // console.log(response)
          let res_data = response.data || {}
          this.kfList = res_data.sk || []
          this.kfList1 = res_data.sk1 || []
          this.kfLoading = false
        }).catch(() => {
          this.kfLoading = false
        })
      },

      getQyData() {
        this.qyLoading = true
        const data = {
          time: this.allSearchForm.time,
          groupid: this.allSearchForm.groupid
        }
        getAreaStatistics(data).then(response => {
          // console.log(response)
          let res_data = response.data || {}
          this.qyList1 = res_data.sk || []
          this.qyList2 = res_data.xd || []
          this.qyList3 = res_data.xd1 || []
          this.qyList4 = res_data.xd2 || []
          this.qyLoading = false
        }).catch(() => {
          this.qyLoading = false
        })
      },

      getJxsData() {
        this.jxsLoading = true
        const data = {
          time: this.allSearchForm.time,
          groupid: this.allSearchForm.groupid
        }
        getDealerOrderStatistics(data).then(response => {
          // console.log(response)
          let res_data = response.data || {}
          this.jxsList1 = res_data.sk || []
          this.jxsList2 = res_data.xd || []
          this.jxsLoading = false
        }).catch(() => {
          this.jxsLoading = false
        })
      },

      getGroupList() {
        getGroupReport().then(response => {
          const arr = []
          for (const item of response.data) {
            if (item.nature === 0) {
              arr.push(item)
            }
          }
          this.groupList = arr
        })
      },

      // 初始图表数据加载
      initChatrsData() {
        let columnData = []

        this.statData.forEach(r => {
          columnData.push({
            name: r.name,
            y: r.value,
            type: r.type
          });
        });

        let chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          chart: {
            type: 'column'
          },
          title: {
            text: '各类收款金额统计图'
          },
          xAxis: {
            type: 'category',
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px;">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> 元<br/>'
          },
          series: [{
            name: '金额统计',
            data: columnData,
            colorByPoint: true,
            cursor: 'pointer',
            allowPointSelect: true, // 是否允许选中点
            events: {
              click: (e) => {
                // console.log(e.point);
                // 加载表格数据
                if (this.typeName != e.point.name) {
                  this.dataType = e.point.options.type || '0'
                  this.page.currentPage = 1
                  this.getTableData(this.dataType, e.point.name)
                }
              }
            }
          }]
        }
        this.columnOption = chart
        // 初始饼图数据
        // this.reloadCircleChatrs()
      },

      // 饼图数据
      reloadCircleChatrs() {
        let circleData = []

        this.statData.forEach(r => {
          circleData.push({
            name: r.name,
            y: r.value
          });
        });

        let circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: '各类收款金额占比图'
          },
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.y} 元</b> <br> 占比: <b>{point.percentage:.2f} %</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b> <br> 金额:  {point.y} 元 <br> 占比: {point.percentage:.2f} %'
              }
            }
          },
          series: [{
            name: '金额',
            colorByPoint: true,
            data: circleData
          }]
        }
        this.circleOption = circle
      },

      handleSizeChange(val) {
        this.page.pageSize = val
        this.getTableData(this.dataType)
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.getTableData(this.dataType)
      },
      // 表格数据 type是需要加载的数据项名称
      getTableData(type, name) {
        if (!this.typeName && !name) return
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          starttime: startTime,
          endtime: endTime,
          groupid: this.searchForm.groupid,
          type: type
        }
        // console.log(data)
        this.tbLoading = true
        // 加载列表数据
        getCollectionDetail(data).then(response => {
          // console.log(response)
          // 表格列
          if (type) this.getTableColumns(type)
          // 切换统计项
          if (name) this.typeName = name
          let list = response.data || []
          this.tableData = list
          this.page.total = response.total
          this.tbLoading = false
        }).catch(() => {
          this.tbLoading = false
        })
      },

      reloadTable() {
        this.page.currentPage = 1
        this.getTableData(this.dataType)
      },

      exportExcel() {
        if (!this.excelLoading) {
          this.excelLoading = true
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          const data = {
            starttime: startTime,
            endtime: endTime,
            groupid: this.searchForm.groupid,
            type: this.dataType
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          excelCollectionDetail(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelLoading = false
          }).catch(() => {
            this.excelLoading = false
          })
        }
      },

      exportKfExcel(type = 0) {
        if (!this.excelLoading) {
          this.excelLoading = true
          const brand = this.allSearchForm.groupid == 1 ? '首造' : '乔金斯'

          const myDate = new Date(this.allSearchForm.time)
          const year = myDate.getFullYear()
          let month = myDate.getMonth() + 1
          let day = myDate.getDate()
          month = month > 9 ? month + '' : '0' + month
          day = day > 9 ? day + '' : '0' + day
          const time_str = year + '年' + month + '月' + day + '日'

          const data = {
            time: this.allSearchForm.time,
            groupid: this.allSearchForm.groupid,
            type: type
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          axios({
            method: 'post',
            url: process.env.VUE_APP_BASE_API + '/api/excelServeStatistics',
            params: data,
            responseType: 'blob', // 表明返回服务器返回的数据类型
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => { // 处理返回的文件流
            this.excelLoading = false
            const blob = new Blob([res.data]);
            const fileName = time_str + ' ' + brand + '品牌 全国' + (type == 0 ? '销售客服' : '区域经理') + '收款总金额.xlsx';
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }).catch(err => {
            this.excelLoading = false
            this.$message({
              type: 'error',
              message: '导出失败，请稍候再试'
            })
          });
        }
      },

      exportQyExcel(type = 0) {
        if (!this.excelLoading) {
          this.excelLoading = true
          const brand = this.allSearchForm.groupid == 1 ? '首造' : '乔金斯'

          const myDate = new Date(this.allSearchForm.time)
          const year = myDate.getFullYear()
          let month = myDate.getMonth() + 1
          let day = myDate.getDate()
          month = month > 9 ? month + '' : '0' + month
          day = day > 9 ? day + '' : '0' + day
          const time_str = year + '年' + month + '月' + day + '日'

          const data = {
            time: this.allSearchForm.time,
            groupid: this.allSearchForm.groupid,
            type: type
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          axios({
            method: 'post',
            url: process.env.VUE_APP_BASE_API + '/api/excelAreaStatistics',
            params: data,
            responseType: 'blob', // 表明返回服务器返回的数据类型
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => { // 处理返回的文件流
            this.excelLoading = false
            const blob = new Blob([res.data]);
            const fileName = time_str + ' ' + brand + '品牌 全国' + (type == 0 ? '收款' : '下单') + (type == 2 ?
              '总业绩.xlsx' : '总金额.xlsx');
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }).catch(err => {
            this.excelLoading = false
            this.$message({
              type: 'error',
              message: '导出失败，请稍候再试'
            })
          });
        }
      },

      exportJxsExcel(type = 0) {
        if (!this.excelLoading) {
          this.excelLoading = true
          const brand = this.allSearchForm.groupid == 1 ? '首造' : '乔金斯'

          const myDate = new Date(this.allSearchForm.time)
          const year = myDate.getFullYear()
          let month = myDate.getMonth() + 1
          let day = myDate.getDate()
          month = month > 9 ? month + '' : '0' + month
          day = day > 9 ? day + '' : '0' + day
          const time_str = year + '年' + month + '月' + day + '日'

          const data = {
            time: this.allSearchForm.time,
            groupid: this.allSearchForm.groupid,
            type: type
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          axios({
            method: 'post',
            url: process.env.VUE_APP_BASE_API + '/api/excelDealerOrderStatistics',
            params: data,
            responseType: 'blob', // 表明返回服务器返回的数据类型
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => { // 处理返回的文件流
            this.excelLoading = false
            const blob = new Blob([res.data]);
            const fileName = time_str + ' ' + brand + '品牌 全国经销商下单' + (type == 1 ? '业绩' : '总金额') + '.xlsx';
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(
              elink.href);
            document.body.removeChild(elink);
          }).catch(err => {
            this.excelLoading = false
            this.$message({
              type: 'error',
              message: '导出失败，请稍候再试'
            })
          });
        }
      },

      rowClassName({
        row,
        rowIndex
      }) {
        // 合计行，则返回CSS类名
        if (row.name === '合计') {
          return 'fixed-row';
        }
        return ''
      },

      cellStyleJxsTable({
        row,
        column
      }) {
        // console.log(row, column)
        if (row.name !== '合计' && (column.property === 'monthMoney' || column.property === 'monthMoneyStr')) {
          if (row.monthMoney >= 100000 && row.monthMoney < 120000) {
            return {
              backgroundColor: '#f8e3c5',
              color: '#b88230'
            }
          } else if (row.monthMoney >= 120000 && row.monthMoney < 180000) {
            return {
              backgroundColor: '#d1edc4',
              color: '#529b2e'
            }
          } else if (row.monthMoney >= 180000 && row.monthMoney < 200000) {
            return {
              backgroundColor: '#eebe77',
              color: '#a9772b'
            }
          } else if (row.monthMoney >= 200000) {
            return {
              backgroundColor: '#95d475',
              color: '#309000'
            }
          }
        }
        return {}
      },

      // 动态设置表格列
      getTableColumns(type) {
        // 3-订单对公收款
        let tableColumns = [{
          label: '订单号',
          prop: 'orderNum',
          minWidth: 120
        }, {
          label: '区域经理',
          prop: 'areaName',
          minWidth: 120
        }, {
          label: '销售客服',
          prop: 'serveName',
          minWidth: 100
        }, {
          label: '经销商',
          prop: 'dealerName',
          minWidth: 120
        }, {
          label: '经销商电话',
          prop: 'dealerTel',
          minWidth: 120
        }, {
          label: '经办人',
          prop: 'username',
          minWidth: 120
        }, {
          label: '收款时间',
          prop: 'receiptTime',
          minWidth: 120
        }, {
          label: '金额',
          prop: 'money',
          color: '#409EFF',
          minWidth: 120
        }, {
          label: '收款账号',
          prop: 'accountName',
          minWidth: 200
        }, {
          label: '收款卡号',
          prop: 'accountCard',
          align: 'left',
          minWidth: 150
        }]

        // 0-订单余额抵扣 5-订单返点抵扣 6-订单售后赔款抵扣 8-订单样品预存款抵扣 109-订单冲业绩抵扣 4-收款抹零总金额
        if (type == '0' || type == '5' || type == '6' || type == '8' || type == '109' || type == '4') {
          tableColumns = [{
            label: '订单号',
            prop: 'orderNum',
            minWidth: 120
          }, {
            label: '区域经理',
            prop: 'areaName',
            minWidth: 120
          }, {
            label: '经销商',
            prop: 'dealerName',
            minWidth: 120
          }, {
            label: '经销商电话',
            prop: 'dealerTel',
            minWidth: 120
          }, {
            label: '经办人',
            prop: 'username',
            minWidth: 120
          }, {
            label: '收款时间',
            prop: 'receiptTime',
            minWidth: 120
          }, {
            label: '金额',
            prop: 'money',
            color: '#409EFF',
            minWidth: 120
          }]
        }
        // 101-物料对公收款
        else if (type == '101') {
          tableColumns = [{
            label: '物料订单编号',
            prop: 'maNum',
            minWidth: 160
          }, {
            label: '区域经理',
            prop: 'areaName',
            minWidth: 100
          }, {
            label: '销售客服',
            prop: 'serveName',
            minWidth: 100
          }, {
            label: '经销商',
            prop: 'dealerName',
            minWidth: 120
          }, {
            label: '经销商电话',
            prop: 'dealerTel',
            minWidth: 120
          }, {
            label: '经办人',
            prop: 'username',
            minWidth: 120
          }, {
            label: '收款时间',
            prop: 'receiptTime',
            minWidth: 120
          }, {
            label: '金额',
            prop: 'money',
            color: '#409EFF',
            minWidth: 120
          }, {
            label: '收款账号',
            prop: 'accountName',
            minWidth: 200
          }, {
            label: '收款卡号',
            prop: 'accountCard',
            align: 'left',
            minWidth: 150
          }]
        }
        // 108-物料订单余额抵扣
        else if (type == '108') {
          tableColumns = [{
            label: '物料订单编号',
            prop: 'maNum',
            minWidth: 160
          }, {
            label: '区域经理',
            prop: 'areaName',
            minWidth: 120
          }, {
            label: '经销商',
            prop: 'dealerName',
            minWidth: 120
          }, {
            label: '经销商电话',
            prop: 'dealerTel',
            minWidth: 120
          }, {
            label: '经办人',
            prop: 'username',
            minWidth: 120
          }, {
            label: '收款时间',
            prop: 'receiptTime',
            minWidth: 120
          }, {
            label: '金额',
            prop: 'money',
            color: '#409EFF',
            minWidth: 120
          }]
        }
        // 102-上月冲业绩、103-冲业绩对公收款 104-账户充值金额 203-其他收款对公收款 403-深化收款对公收款
        else if (type == '102' || type == '103' || type == '104' || type == '203' || type == '403') {
          tableColumns = [{
            label: '区域经理',
            prop: 'areaName',
            minWidth: 100
          }, {
            label: '销售客服',
            prop: 'serveName',
            minWidth: 100
          }, {
            label: '经销商',
            prop: 'dealerName',
            minWidth: 120
          }, {
            label: '经销商电话',
            prop: 'dealerTel',
            minWidth: 120
          }, {
            label: '经办人',
            prop: 'username',
            minWidth: 120
          }, {
            label: '收款时间',
            prop: 'receiptTime',
            minWidth: 120
          }, {
            label: '金额',
            prop: 'money',
            color: '#409EFF',
            minWidth: 120
          }, {
            label: '收款账号',
            prop: 'accountName',
            minWidth: 200
          }, {
            label: '收款卡号',
            prop: 'accountCard',
            align: 'left',
            minWidth: 150
          }]
        }
        // 1022-上月冲业绩账户抵扣  1033-冲业绩余额抵扣 2033-其他收款余额抵扣 4033-深化收款余额抵扣
        else if (type == '1022' || type == '1033' || type == '2033' || type == '4033') {
          tableColumns = [{
            label: '区域经理',
            prop: 'areaName',
            minWidth: 120
          }, {
            label: '经销商',
            prop: 'dealerName',
            minWidth: 120
          }, {
            label: '经销商电话',
            prop: 'dealerTel',
            minWidth: 120
          }, {
            label: '经办人',
            prop: 'username',
            minWidth: 120
          }, {
            label: '收款时间',
            prop: 'receiptTime',
            minWidth: 120
          }, {
            label: '金额',
            prop: 'money',
            color: '#409EFF',
            minWidth: 120
          }]
        }
        // 105 样品预存款
        else if (type == '105') {
          tableColumns = [{
            label: '区域经理',
            prop: 'areaName',
            minWidth: 120
          }, {
            label: '经销商',
            prop: 'dealerName',
            minWidth: 120
          }, {
            label: '经销商电话',
            prop: 'dealerTel',
            minWidth: 120
          }, {
            label: '经办人',
            prop: 'username',
            minWidth: 120
          }, {
            label: '收款时间',
            prop: 'receiptTime',
            minWidth: 160
          }, {
            label: '加盟费',
            prop: 'jmj',
            color: '#409EFF',
            minWidth: 120
          }, {
            label: '样品预存款',
            prop: 'yck',
            color: '#409EFF',
            minWidth: 120
          }, {
            label: '总金额',
            prop: 'money',
            color: '#409EFF',
            minWidth: 120
          }]
        }
        // 106-业绩返点、107-售后赔款
        else if (type == '106' || type == '107') {
          tableColumns = [{
            label: type == '106' ? '业绩返点名称' : '售后赔款名称',
            prop: 'name',
            minWidth: 200
          }, {
            label: '区域经理',
            prop: 'areaName',
            minWidth: 120
          }, {
            label: '经销商',
            prop: 'dealerName',
            minWidth: 120
          }, {
            label: '经销商电话',
            prop: 'dealerTel',
            minWidth: 120
          }, {
            label: '经办人',
            prop: 'username',
            minWidth: 120
          }, {
            label: '收款时间',
            prop: 'receiptTime',
            minWidth: 160
          }, {
            label: '金额',
            prop: 'money',
            color: '#409EFF',
            minWidth: 120
          }]
        }
        // 110-过预付款订单总金额  111-使用过抵扣冲业绩且已过预付款的订单总金额
        else if (type == '110' || type == '111') {
          tableColumns = [{
            label: '订单号',
            prop: 'ordernum',
            width: 120
          }, {
            label: '区域经理',
            prop: 'areaName',
            minWidth: 120
          }, {
            label: '经销商',
            prop: 'delname',
            width: 120
          }, {
            label: '详细地址',
            prop: 'address',
            align: 'left',
            minWidth: 160
          }, {
            label: '时间',
            prop: 'time',
            width: 160
          }, {
            label: '客户承担',
            prop: 'clientcom',
            color: '#409EFF'
          }, {
            label: '设计师承担',
            prop: 'designcom',
            color: '#409EFF',
            width: 120
          }, {
            label: '工厂承担',
            prop: 'factorycom',
            color: '#409EFF'
          }, {
            label: '其他',
            prop: 'other',
            color: '#409EFF'
          }, {
            label: '更改单金额',
            prop: 'changes',
            color: '#409EFF',
            width: 120
          }, {
            label: '优惠',
            prop: 'best',
            color: '#409EFF'
          }, {
            label: '退款金额',
            prop: 'refund',
            color: '#409EFF'
          }, {
            label: '已支付',
            prop: 'paidfor',
            color: '#409EFF',
            fixed: 'right'
          }, {
            label: '实际金额',
            prop: 'amount',
            color: '#409EFF',
            fixed: 'right'
          }, {
            label: '总金额',
            prop: 'totalprice',
            color: '#409EFF',
            fixed: 'right'
          }]
        }

        this.tableColumns = tableColumns
      },

    }
  }
</script>

<style lang="scss">
  .chart-column {
    .highcharts-point-select {
      fill: #ff0000 !important;
    }
  }

  .el-table__body .fixed-row {
    position: sticky;
    bottom: 0;
    width: 100%;
    height: 50px;
    background-color: #f5f7fa;
  }

  .el-table__body .fixed-row td {
    border-top: 1px solid #EBEEF5;
  }

  .custom-table {

    .el-table th {
      border-color: rgb(70, 69, 69) !important;
    }

    .el-table td {
      border-color: rgb(140, 139, 139) !important;
    }

    .el-table--group,
    .el-table--border {
      border: 0.1px solid rgb(70, 69, 69) !important;
    }
  }
</style>

<style lang="scss" scoped>
  .card-title {
    margin-bottom: 10px !important;
  }
</style>
